import { render, staticRenderFns } from "./tableHead.vue?vue&type=template&id=0d5aab6d&"
import script from "./tableHead.vue?vue&type=script&lang=ts&"
export * from "./tableHead.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports